import { render, staticRenderFns } from "./GradientArrow.vue?vue&type=template&id=7c963854&scoped=true&"
import script from "./GradientArrow.vue?vue&type=script&lang=js&"
export * from "./GradientArrow.vue?vue&type=script&lang=js&"
import style0 from "./GradientArrow.vue?vue&type=style&index=0&id=7c963854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c963854",
  null
  
)

export default component.exports